import * as actionTypes from '../actions/actionTypes';

const initialState = {
    portals: null,
    portalsInfo: null,
    portalInfoCounter: 0,
    addEligPortal: null,
    message: null,
    portalsLoading: true,
    portalInfoLoading: false,
    addingEligibility: false,
    eligibilityAdded: false,

    modifyEligPortal: null,
    modifyEligSelectedPortal: null,
    modifyEligMessage: null,
    updatingEligibility: false,
    eligibilityUpdated: false,
    memberFaroID: null,
    memberGroupID: null,
    showModifyEligModal: false,
    showAddEligModal: false,
    disabledPortals: []
}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_ELIG_PORTALS_START:
            return {
                ...state,
                portalsLoading: true
            }
        case actionTypes.FETCH_ELIG_PORTALS_SUCCESS:
            return {
                ...state,
                portals: action.portals,
                portalsLoading: false,
                // modifyEligSelectedPortal: action.portals && state.modifyEligPortal?{...action.portals.find( portal => portal.portalShortName = state.modifyEligPortal.portalShortNm)}:null
            }
        case actionTypes.FETCH_ELIG_PORTALS_FAILURE:
            return {
                ...state,
                portalsLoading: false
            }
        case actionTypes.FETCH_DISABLED_PORTAL_SUCCESS:
            return {
                ...state,
                disabledPortals: action.payload
            }
        case actionTypes.FETCH_ELIG_PORTAL_INFO_START:
            return {
                ...state,
                portalInfoLoading: true,
                portalsInfo: null,
                portalInfoCounter: 0,
            }
        case actionTypes.FETCH_ELIG_PORTAL_INFO_SUCCESS:
            return {
                ...state,
                portalsInfo: {
                    ...state.portalsInfo,
                    [action.portalInfo.portalShortName]: action.portalInfo
                },
                portalInfoCounter: state.portalInfoCounter+1,
                portalInfoLoading: !(state.portals.length === state.portalInfoCounter+1)
            }
        case actionTypes.FETCH_ELIG_PORTAL_INFO_FAILURE:
            return {
                ...state,
                error: action.error,
                portalInfoCounter: state.portalInfoCounter+1,
                portalInfoLoading: !(state.portals.length === state.portalInfoCounter+1)
            }
        case actionTypes.FETCH_ELIG_PORTAL_INFO_TOGGLE:
            return {
                ...state,
                portalInfoLoading: !state.portalInfoLoading
            }

        case actionTypes.SET_ELIG_DISPLAY_MESSAGE:
            return {
                ...state,
                message: action.message
            }

        case actionTypes.FETCH_ELIG_FARO_ID_START:
            return {
                ...state,
                portalInfoLoading: true,
                showModifyEligModal: false,
                showAddEligModal: false,
                memberFaroID: null,
            }
        case actionTypes.FETCH_ELIG_FARO_ID_SUCCESS:
            return {
                ...state,
                portalInfoLoading: false,
                memberFaroID: action.faroId,
                showModifyEligModal: true,
                showAddEligModal: true,
            }
        case actionTypes.FETCH_ELIG_FARO_ID_FAILURE:
            return {
                ...state,
                portalInfoLoading: false,
                message: action.type && action.operation==="ADD"?{type: "Error", info: {message: "No user found in Optum Bank."}}: state.message,
                modifyEligMessage: action.operation && action.operation==="MODIFY"?{type: "Error", info: {message: "No user found in Optum Bank."}}: state.modifyEligMessage
            }

        case actionTypes.FETCH_ELIG_GROUP_ID_START:
            return {
                ...state,
                portalInfoLoading: true,
                showModifyEligModal: false,
                showAddEligModal: false,
                memberGroupID: null,
            }
        case actionTypes.FETCH_ELIG_GROUP_ID_SUCCESS:
            return {
                ...state,
                portalInfoLoading: false,
                memberGroupID: action.groupId,
                showModifyEligModal: true,
                showAddEligModal: true,
            }
        case actionTypes.FETCH_ELIG_GROUP_ID_FAILURE:
            return {
                ...state,
                portalInfoLoading: false,
                message: action.type && action.operation==="ADD"?{type: "Error", info: {message: action.error}}: state.message,
                modifyEligMessage: action.operation && action.operation==="MODIFY"?{type: "Error", info: {message: action.error}}: state.modifyEligMessage
            }

        case actionTypes.SET_ADD_ELIGIBILITY_PORTAL:
            return {
                ...state,
                addEligPortal: action.portalInfo
            }
        case actionTypes.ADD_ELIGIBILITY_START:
            return {
                ...state,
                message: null,
                addingEligibility: true,
                eligibilityAdded: false,
            }
        case actionTypes.ADD_ELIGIBILITY_SUCCESS:
            return {
                ...state,
                addingEligibility: false,
                eligibilityAdded: true,
                showModifyEligModal: false,
                showAddEligModal: false,
                message: action.operation && action.operation==="ADD"?{type: "Success", info: {message: "Member Eligibility has been successfully added."}}: state.message,
                modifyEligMessage: action.operation && action.operation==="MODIFY"?{type: "Success", info: {message: "Member Eligibility has been successfully updated."}}: state.modifyEligMessage,
            }
        case actionTypes.ADD_ELIGIBILITY_FAILURE:
            return {
                ...state,
                addingEligibility: false,
                eligibilityAdded: false,
                showAddEligModal: false,
                showModifyEligModal: false,
                message: {type: "Error", info: {message: action.error.message ? action.error.message : "Member Eligibility failed to be added."}},
                modifyEligMessage: {type: "Error", info: {message: action.error.message ? action.error.message : "Member Eligibility failed to be added."}}
            }
        case actionTypes.SET_MODIFY_ELIGIBILITY_PORTAL:
            return {
                ...state,
                modifyEligPortal: action.portal,
            }
        case actionTypes.SET_MODIFY_ELIGIBILITY_SELECTED_PORTAL:
            return {
                ...state,
                modifyEligSelectedPortal: action.portal
            }
        case actionTypes.MODIFY_PORTAL_ELIGIBILITY_MESSAGE:
            return {
                ...state,
                modifyEligMessage: action.message
            }
        case actionTypes.SET_MEMBER_ELIG_MESSAGE:
            return {
                ...state,
                message: null,
                modifyEligMessage: null
            }
        case actionTypes.MODIFY_ELIGIBILITY_MODAL_TOGGLE:
            return {
                ...state,
                showModifyEligModal: !state.showModifyEligModal
            }
        case actionTypes.ADD_ELIGIBILITY_MODAL_TOGGLE:
            return {
                ...state,
                showAddEligModal: !state.showAddEligModal
            }
        case actionTypes.MERGE_PORTALS_INFO:
            return {
                ...state,
                portalsInfo: action.portalInfo
            }
        case actionTypes.MERGE_PORTALS_LIST:
            return {
                ...state,
                portals: action.portalsList
            }
        default:
            return {
                ...state
            }
    }
}

export default reducer;